var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"city-select"},[_c('el-cascader',{ref:"select",attrs:{"size":"mini","props":_vm.props,"value":_vm.value,"options":_vm.regionList,"filterable":_vm.filterable},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }